import { h } from 'preact';
import styled from 'styled-components';

const WrapperNewInviteComponent = styled.div`
    background-color: ${props => props.backgroundColor || '#f5f6f7'};
    border-top:${({position})=> position === 'bottom' ? ' 1px solid #afafaf' : 'none'};
    border-bottom: ${({position})=> position === 'top' ? '1px solid #afafaf' : 'none'};
    direction: ${({isDirectionRtl})=> isDirectionRtl ? 'rtl' : 'ltr'};
    width: 100%;
    color: #333;
    min-height: 84px;
    font-family: "Open Sans";
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: stretch;
    overflow: hidden;
    height: fit-content;
`; 

export default WrapperNewInviteComponent;
